<template>
    <div class="row">
        <div class="col-xs-12">
            <job />
            <div class="description">
                Es freut uns, dass Sie sich bei uns bewerben möchten! Bitte
                füllen Sie das folgende Formular aus.
            </div>
            <form class="contact-form" autocomplete="off">
                <h2>Persönliche Daten</h2>
                <div class="form-container">
                    <div class="form-inner">
                        <div class="row">
                            <div class="col-xs-12">
                                <v-input
                                    v-model="formData.title"
                                    name="title"
                                    label="Anrede *"
                                    validate="required"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-input
                                    v-model="formData.firstname"
                                    name="firstname"
                                    label="Vorname *"
                                    validate="required"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-input
                                    v-model="formData.lastname"
                                    name="lastname"
                                    label="Nachname *"
                                    validate="required"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-input
                                    v-model="formData.date_of_birth"
                                    name="date_of_birth"
                                    label="Geburtsdatum *"
                                    validate="required|date_format:dd.MM.yyyy"
                                />
                            </div>
                            <div class="col-xs-12 col-sm-6">
                                <v-input
                                    @input="handleInput('street')"
                                    @selectAutocomplete="selectPlace"
                                    @blur="hideAllAutocomplete"
                                    v-model="formData.street"
                                    name="street"
                                    label="Straße *"
                                    validate="required"
                                    :show-autocomplete="showDatalist.street"
                                    :autocomplete-elements="places"
                                    autocomplete="street"
                                />
                            </div>

                            <div class="col-xs-12 col-sm-6">
                                <v-input
                                    v-model="formData.house_number"
                                    name="house_number"
                                    label="Hausnummer *"
                                    validate="required"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-input
                                    v-model="formData.additional"
                                    name="additional"
                                    label="Adresszusatz"
                                />
                            </div>

                            <div class="col-xs-12 col-sm-4">
                                <v-input
                                    v-model.lazy="formData.plz"
                                    name="postcode"
                                    label="PLZ *"
                                    validate="required|numeric"
                                    autocomplete="postcode"
                                />
                            </div>

                            <div class="col-xs-12 col-sm-8">
                                <v-input
                                    v-model.lazy="formData.city"
                                    name="city"
                                    label="Ort *"
                                    validate="required"
                                    autocomplete="city"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-input
                                    v-model.lazy="formData.country"
                                    name="country"
                                    label="Land *"
                                    validate="required"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-date-picker
                                    v-model="formData.startDate"
                                    name="startDate"
                                    mode="date"
                                    :masks="{ input: 'DD.MM.YYYY'}"
                                    :input-props="{
                                        required: true,
                                        readonly: true,
                                        'data-vv-as':
                                            'Frühestmöglicher Starttermin',
                                    }"
                                    @input="onDateChange"
                                >
                                    <template
                                        v-slot="{ inputValue, inputEvents }"
                                    >
                                        <div
                                            class="form-group text"
                                            :class="
                                                errors.has('startDate')
                                                    ? 'error'
                                                    : ''
                                            "
                                        >
                                            <label
                                                :class="
                                                    formData.startDate
                                                        ? 'label-focus'
                                                        : ''
                                                "
                                            >
                                                Frühestmöglicher Starttermin *
                                                <span
                                                    v-if="
                                                        errors.has('startDate')
                                                    "
                                                    class="errors"
                                                >
                                                    -
                                                    {{
                                                        errors.first(
                                                            "startDate"
                                                        )
                                                    }}
                                                </span>
                                            </label>
                                            <input
                                                class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
                                                :value="inputValue"
                                                v-on="inputEvents"
                                                v-validate="'required'"
                                                name="startDate"
                                                readonly
                                                inputmode="none"
                                                autocomplete="off"
                                                @input="
                                                    validateField('startDate')
                                                "
                                            />
                                        </div>
                                    </template>
                                </v-date-picker>
                            </div>

                            <div class="col-xs-12 mt-m">
                                <v-select
                                    v-model="formData.aufmerksam"
                                    :options="[
                                        {
                                            value: null,
                                            label: 'Bitte auswählen',
                                        },
                                        {
                                            value: 'Analoge Anzeige in der Zeitung',
                                            label: 'Analoge Anzeige in der Zeitung',
                                        },
                                        {
                                            value: 'Digitale Anzeige im Internet',
                                            label: 'Digitale Anzeige im Internet',
                                        },
                                        {
                                            value: 'Kinowerbung',
                                            label: 'Kinowerbung',
                                        },
                                        {
                                            value: 'Social Media (Facebook / Instagram)',
                                            label: 'Social Media (Facebook / Instagram)',
                                        },
                                        {
                                            value: 'Sponsoring (Trikots,...)',
                                            label: 'Sponsoring (Trikots,...)',
                                        },
                                        {
                                            value: 'Empfehlung / Hörensagen',
                                            label: 'Empfehlung / Hörensagen',
                                        },
                                    ]"
                                    name="aufmerksam"
                                    label="* Aufmerksam geworden durch"
                                    validate="required"
                                />
                            </div>

                            <div
                                class="col-xs-12"
                                v-if="
                                    formData.aufmerksam ===
                                    'Empfehlung / Hörensagen'
                                "
                            >
                                <v-input
                                    v-model="formData.aufmerksamInfo"
                                    name="aufmerksamInfo"
                                    label="Empfehlungsgeber"
                                />
                            </div>

                            <div class="col-xs-12">
                                <v-input
                                    v-model="formData.terms"
                                    type="checkbox"
                                    name="terms"
                                    label="* Ich habe die <a href='/index.php?id=20' target='_blank'>Datenschutzinformationen</a> zur Kenntnis genommen."
                                    validate="required"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-md-6 col-md-offset-6">
                            <div
                                @click="$emit('submit', formData)"
                                class="btn btn-green btn-big submit"
                            >
                                weiter
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="col-xs-12">
                            <p class="notice">
                                Mit * markierte Felder sind Pflichtfelder.
                            </p>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import VInput from "./v-input";
import VSelect from "./v-select";
import Job from "./job";
import _ from "lodash";

export default {
    inject: ["$validator"],
    computed: {
        formData() {
            return this.$store.state.stepPersonalData;
        },
    },
    data() {
        return {
            job: "",
            apiKey: "pk.eyJ1IjoiamFtZXMta2FuIiwiYSI6ImNtNHR3MGphOTAwN3kycnF1eHA4dnN2aXEifQ.4_RYI2izO-wcJwLbGpdYpg",
            autocompleteUrl: "https://api.mapbox.com/search/geocode/v6/forward",
            autocompleteQuery: "",
            places: [],
            showDatalist: [],
        };
    },

    methods: {
        validateField(descriptor) {
            return new Promise((resolve) => {
                this.$nextTick(() => {
                    this.$validator.validate(descriptor).then((result) => {
                        resolve(result);
                    });
                });
            });
        },

        onDateChange(newDate) {
            const date = new Date(newDate);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 weil Monate bei 0 starten
            const day = String(date.getDate()).padStart(2, '0');

            const formatted = `${day}.${month}.${year}`;
            this.$set(this.formData, "startDate", formatted);
            this.validateField("startDate");
        },

        debouncedSearch: _.debounce(function (query, type) {
            if (type === "plz") {
                type = "postcode";
            }
            this.searchPlaces(query, type);
        }, 100),
        handleInput(type) {
            let query = this.formData[type];
            this.updateFormData(type, query);
            if (query.length >= 2) {
                this.debouncedSearch(query, type);
            } else {
                this.places = [];
            }
        },
        async searchPlaces(query, type) {
            try {
                const response = await fetch(
                    `${this.autocompleteUrl}?q=${query}&proximity=ip&access_token=${this.apiKey}`
                );
                const data = await response.json();
                this.places = [...data.features];
                this.showDatalist[type] = true;
                this.$emit("update:autocompleteElements", this.places);
            } catch (error) {
                console.error("Error searching places:", error);
            }
        },

        selectPlace(place, type) {
            const properties = place.properties;
            this.$set(this.formData, "street", properties.name || "");
            this.$set(
                this.formData,
                "plz",
                properties.context.postcode?.name || ""
            );
            this.$set(
                this.formData,
                "city",
                properties.context.place?.name || ""
            );
            this.$set(
                this.formData,
                "country",
                properties.context.country?.name || ""
            );

            this.showDatalist.street = false;
            this.showDatalist.plz = false;
            this.showDatalist.city = false;
            this.showDatalist.country = false;

            this.places = [];
            document.activeElement.blur();
        },
        handleClickOutside(event) {
            const autocompleteList =
                document.querySelector(".autocomplete-list");
            if (autocompleteList && !autocompleteList.contains(event.target)) {
                this.hideAllAutocomplete();
            }
        },

        hideAllAutocomplete() {
            this.showDatalist = {
                street: false,
                plz: false,
                city: false,
                country: false,
            };
            this.places = [];
        },
        updateFormData(field, value) {
            this.$store.commit("updateStepPersonalData", { [field]: value });
        },
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },

    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    components: {
        VSelect,
        VInput,
        Job,
    },
};
</script>
